(function ($) {
  $(document).ready(function () {
    var body = $("body");
    body.find("footer").prepend('<a href="#wp--skip-link--target" class="back-to-top" aria-label="Scroll to the top of the page"></a>');
    var contBack = body.find(".back-to-top");
    $(window).scroll(function () {
      if ($(window).scrollTop() > 1000) {
        contBack.addClass("active");
      } else {
        contBack.removeClass("active");
      }
    });
    contBack.on("click", function () {
      body.removeClass("scroll-overflow-hidden");
    });
  });

  $(window).on("load", function () {
    const hash = window.location.hash;
    if (hash && $(hash).length) {
      $(hash)[0].scrollIntoView();
    }
  });
})(jQuery);
